export interface SupportIens {
    name: string;
    path: string;
    isInternal: boolean;
}

export const supportItens: SupportIens[] = [
    {
        name: 'Manual abertura de chamados 2025 - SmartCargas - Externo',
        path: '/files/Manual abertura de chamados 2025 - SmartCargas - Externo.pdf',
        isInternal: false,
    },
    {
        name: 'Manual abertura de chamados 2025 - SmartCargas - Interno',
        path: '/files/Manual abertura de chamados 2025 - SmartCargas - Interno.pdf',
        isInternal: true,
    },
    {
        name: 'Manual SmartCargas - Versão mobile',
        path: '/files/Manual SmartCargas - Versão mobile.pdf',
        isInternal: false,
    },
    {
        name: 'Manual SmartCargas - Versão WEB',
        path: '/files/Manual SmartCargas - Versão WEB.pdf',
        isInternal: false,
    },
    {
        name: 'Manual do Sulahub',
        path: '/files/SmartCargas_ManualSulahub.pdf',
        isInternal: true,
    },
];
